import React from 'react';
import './AIConsentModal.css';

function AIConsentModal({ onAccept, onDecline }) {
  return (
    <div className="ai-consent-overlay">
      <div className="ai-consent-modal">
        <div className="ai-consent-icon">🤖</div>
        <h2>AI Features & Data Privacy</h2>
        <p className="ai-consent-intro">
          AirFlyp uses third-party AI services to power transcription, insights, and AI Persona features.
        </p>

        <div className="ai-consent-details">
          <div className="ai-consent-row">
            <span className="ai-consent-label">What is sent:</span>
            <span>Session audio, notes, and conversation text</span>
          </div>
          <div className="ai-consent-row">
            <span className="ai-consent-label">Sent to:</span>
            <span>OpenAI (transcription & insights) and ElevenLabs (voice)</span>
          </div>
          <div className="ai-consent-row">
            <span className="ai-consent-label">Purpose:</span>
            <span>To generate transcripts, coaching insights, and AI responses</span>
          </div>
        </div>

        <p className="ai-consent-note">
          Your data is handled in accordance with our{' '}
          <a href="https://www.airflyp.com/privacy-policy.html" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          . You can withdraw consent at any time in Settings.
        </p>

        <div className="ai-consent-buttons">
          <button className="ai-consent-accept" onClick={onAccept}>
            I Agree — Enable AI Features
          </button>
          <button className="ai-consent-decline" onClick={onDecline}>
            No Thanks
          </button>
        </div>
      </div>
    </div>
  );
}

export default AIConsentModal;